export class StartCourseCyLRequest {
    data: string;
    
    constructor(data: string) {
        this.data = data;
    }
}